<template>
  <ValidationProvider rules="required" v-slot="{ errors }" vid="pageKey">
    <v-select
      label="Page*"
      v-model="innerValue"
      :items="
        pages.map(x => ({
          text: x.displayName,
          value: x.key
        }))
      "
      :disabled="locked"
      outlined
      :error-messages="errors"
    ></v-select>
  </ValidationProvider>
</template>

<script>
export default {
  data: () => ({
    innerValue: ""
  }),
  props: {
    value: {
      type: String,
      default: ""
    },
    pages: {
      type: Array,
      required: true
    },
    locked: Boolean
  },
  watch: {
    value(val) {
      if (val != this.innerValue) {
        this.innerValue = JSON.parse(JSON.stringify(val));
      }
    },
    innerValue(value) {
      if (value != this.value) this.$emit("input", value);
    }
  },
  mounted() {
    if (this.value) {
      this.innerValue = JSON.parse(JSON.stringify(this.value));
    }
  }
};
</script>
